import React from 'react'

interface Props {}

const ManageUsers: React.FC<Props> = () => {
  return <div>ManageUsers</div>
}

export default ManageUsers
